export const BACKEND_API = 'https://api-rh.b-link.io/';
// export const BACKEND_API = 'http://localhost:9088/';
export const API_URLS = {

};
